module.exports = __webpack_public_path__ + "9de82503040e579e72f689c6c0412cdf.svg";